import Promise from 'promise'
import axios from 'axios'

const LMS_USER_API_URL = '/api'
axios.defaults.withCredentials = true

export default class SessionResource {
  createByPassword (username, password) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: LMS_USER_API_URL + '/session',
        data: {username: username, password: password}
      })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }

  createByToken (token) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: LMS_USER_API_URL + '/session',
        data: {token: token}
      })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }

  get () {
    return new Promise((resolve, reject) => {
      axios.get(LMS_USER_API_URL + '/session')
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }

  destroy () {
    return new Promise((resolve, reject) => {
      axios.delete(LMS_USER_API_URL + '/session')
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }

  // one of username or email is required
  resetPassword (knownInputs) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: LMS_USER_API_URL + '/session/reset-password',
        data: knownInputs
      })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }

  resetPasswordGet (id) {
    return new Promise((resolve, reject) => {
      axios.get(LMS_USER_API_URL + '/session/reset-password/' + id)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }

  resetPasswordSave (id, newPassword) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: LMS_USER_API_URL + '/session/reset-password/' + id,
        data: { newPassword: newPassword }
      })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }

  pingDb () {
    return axios({
      method: 'get',
      url: LMS_USER_API_URL + '/session/ping_db'
    })
  }
}



// WEBPACK FOOTER //
// ./src/backend-resources/session-resource.js